import { IToastMessage } from './interface';

export const STORE_NAME = 'ToastStore';

export interface IToastMessagePrv extends IToastMessage {
    id: string;
}

export type ToastStorage = Array<IToastMessagePrv>;
